<template>
  <el-container class="header-container">
    <el-header>
      <div class="header-left">
        <span class="platform-name">长三角算力公共服务平台</span>
        <span class="platform-name-en"
          >Chang San Jiao Computing Power Public Service Platform</span
        >
      </div>
      <div class="header-menu">
        <el-menu
          :default-active="activeIndex"
          mode="horizontal"
          :router="true"
          class="main-menu"
        >
          <el-menu-item index="/portal">首页</el-menu-item>
          <el-menu-item index="/compute">算力市场</el-menu-item>
          <el-menu-item index="/infra">我的订单</el-menu-item>
          <el-submenu index="/zspt" v-if="accessToken" popper-class="zspt-submenu">
            <template slot="title">智算平台</template>
            <!-- <el-menu-item index="/zspt/computility">算力市场</el-menu-item> -->
            <el-menu-item index="/zspt/aistudio">一站式AI平台</el-menu-item>
            <el-menu-item index="/zspt/maas">大模型服务平台</el-menu-item>
          </el-submenu>
          <el-menu-item index="/cspt" v-if="accessToken">超算平台</el-menu-item>
<!--          <el-menu-item index="/service">服务支持</el-menu-item>-->
        </el-menu>
      </div>
      <div class="header-right">
        <div class="console-btn" @click="goToAdmin" v-if="userType == 1">
          <img
            class="console-btn-icon"
            src="../assets/img/kongzhizhongxin.png"
            alt=""
          />
          控制台
        </div>
        <div class="login-btn" v-if="!accessToken" @click="handleLogin">
          登录/注册
        </div>
        <div class="exit-btn" v-if="accessToken" @click="toggleDropdown">
          <img class="avatar-icon" src="../assets/img/touxiang.png" alt="" />
<!--          <img-->
<!--            class="exit-btn-icon"-->
<!--            src="../assets/img/tuichudenglu.png"-->
<!--            @click="handleLogout"-->
<!--            alt=""-->
<!--          />-->
<!--          <button class="exit-btn-text" @click="handleLogout">退出登录</button>-->
          <div class="dropdown-menu" v-if="isDropdownVisible">
            <button class="exit-btn-text" @click="handleLogout">退出登录</button>
          </div>
        </div>
      </div>
    </el-header>
  </el-container>
</template>

<script>
import { mapActions } from "vuex";
import website from "@/config/website";
import { mapGetters } from "vuex";
import { gotoReLogin } from "@/utils/ncnp";
export default {
  name: "Header",

  data() {
    return {
      activeIndex: this.$route.path,
      isDropdownVisible: false, // 添加状态变量控制下拉菜单显示
    };
  },
  computed: {
    ...mapGetters(["accessToken", "userType"]),
  },
  created() {
    this.activeIndex = this.$route.path;
  },
  watch: {
    "$route.path": {
      handler(newPath) {
        this.activeIndex = newPath;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions("user", ["checkTokenValidity", "logout"]),
    //跳转到管理后台
    goToAdmin() {
      this.$router.push({
        path: "/admin/compute/resource",
      });
    },
    //跳转到登录页面
    handleLogin() {
      // NCNP 用户走 welcome task_id=login，其余走 CA SSO
      gotoReLogin();
    },
    //退出登录
    async handleLogout() {
      try {
        await this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });

        // 检查token是否有效
        let res = await this.checkTokenValidity();
        // 调用logout方法
        await this.logout(res.isValid);
        // 跳转到登录页面
        if (this.$route.path !== "/portal") {
          this.$router.push({ path: "/portal" });
        } else {
          window.location.reload();
        }
        this.$message.success("退出成功");
        this.isDropdownVisible = false; // 退出登录后隐藏下拉菜单
      } catch (error) {
        // 用户点击了取消按钮，不执行退出操作
        console.log('用户取消了退出登录操作');
      }
    },

    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible; // 切换下拉菜单的显示状态
    },
  },
};
</script>

<style scoped lang="scss">
.header-container {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  min-width: 1400px;

  .el-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 92px !important;
    padding: 0 241px;

    .header-left {
      display: flex;
      flex-direction: column;

      .platform-name {
        font-weight: bold;
        font-size: 24px;
        letter-spacing: 3px;
        font-family: AlimamaShuHeiTi, AlimamaShuHeiTi;
      }

      .platform-name-en {
        font-size: 11px;
        color: #999999;
      }
    }

    .header-menu {
      flex: 1;
      display: flex;
      justify-content: center;
      margin-left: 80px;

      .main-menu {
        border-bottom: none;
        background-color: transparent;

        .el-menu-item {
          font-size: 16px;
          height: 72px;
          line-height: 72px;
          padding: 0 10px;
          margin: 0 16px;
          color: #666;
          font-weight: 500;

          &:hover,
          &.is-active {
            color: #065bf3;
            border-bottom: 2px solid #065bf3;
          }
        }

        // el-submenu（智算平台）标题与同级 el-menu-item 保持同行同高同字号
        // 注意：.el-submenu__title 由 Element UI 内部 render 生成，不携带 scoped 属性，
        // 必须用 ::v-deep 穿透 scoped 边界，否则样式不生效
        ::v-deep .el-submenu__title {
          font-size: 16px;
          height: 72px;
          line-height: 72px;
          padding: 0 10px;
          margin: 0 16px;
          color: #666;
          font-weight: 500;
          border-bottom: 2px solid transparent;

          &:hover,
          &.is-active {
            color: #065bf3;
            border-bottom: 2px solid #065bf3;
          }
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 20px;

      .login-btn {
        width: 118px;
        height: 40px;
        background: #067bf3;
        border-radius: 50px;
        font-size: 14px;
        font-weight: 500;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
          background-color: #2990f9;
          border-color: #2990f9;
        }
      }
      .exit-btn {
        position: relative;
        display: flex;
        align-items: center;
        cursor: pointer;

        .avatar-icon {
          width: 50px;
          height: 50px;
          margin-right: 20px;
        }

        .exit-btn-icon {
          height: 22px;
          cursor: pointer;
        }
        .exit-btn-text {
          width: 100px;
          height: 40px;
          background: #f0f0f0;
          border: none;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 500;
          color: #666;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;

          &:hover {
            background-color: #e0e0e0;
            color: #065bf3;
          }
        }
      }

      .console-btn {
        width: 118px;
        height: 40px;
        background: #ebeff7;
        border-radius: 50px;
        font-size: 14px;
        font-weight: 500;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .console-btn-icon {
          height: 19px;
          margin-right: 4px;
        }

        &:hover {
          color: #067bf3;
          border-color: #067bf3;
          background-color: rgba(6, 123, 243, 0.1);
        }
      }
    }
  }
}
</style>

<style lang="scss">
// 智算平台下拉弹层（popper 渲染在 body 下，scoped 无法穿透，单独非 scoped 块）
.zspt-submenu {
  .el-menu-item {
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    color: #666;

    &:hover,
    &.is-active {
      color: #065bf3;
      background-color: rgba(6, 91, 243, 0.06);
    }
  }
}
</style>
